export default "/images/vendor/flag-icon-css/flags/4x3/ie.svg?0542b94612db83a2f5502811528ac249";